import { ChangeDetectorRef, Component, EventEmitter, Inject, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MyButtonComponent } from 'src/app/shared/components/buttons/my-button/my-button.component';
import { DialogData } from 'src/app/shared/components/dialogs/get-time/get-time.component';
import { MatDividerModule } from '@angular/material/divider';
import { MatSelect, MatSelectModule } from '@angular/material/select';
import { InputNumberComponent } from "../../../../shared/components/inputs/input-number/input-number.component";
import { InputTextComponent } from "../../../../shared/components/inputs/input-text/input-text.component";
import { AbstractControl, FormArray, FormBuilder,FormsModule, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { ControlloSingoloService } from '../../controllo-singolo.service';
import { DialogService } from 'src/app/core/services/dialog.service';

@Component({
  selector: 'app-my-dialog',
  standalone: true,
  imports: [
    MatDialogModule,
    MyButtonComponent,
    CommonModule,
    MatDividerModule,
    MatSelect,
    MatSelectModule,
    InputNumberComponent,
    InputTextComponent,
    FormsModule,
    ReactiveFormsModule
  ],
  templateUrl: './my-dialog-insert-parametri.component.html',
  styleUrl: './my-dialog-insert-parametri.component.css'
})
export class MyDialogComponentInsertParametri {
  idParamentro=this.data.parametroInsert.shift().id
  item:any;
  formUpdate:FormGroup;

  constructor(
    private dialogService: DialogService,
    private service:ControlloSingoloService,
    public dialogRef: MatDialogRef<MyDialogComponentInsertParametri>, 
       private readonly fb: FormBuilder,
      @Inject(MAT_DIALOG_DATA) public data: DialogData | any,
       private cdr : ChangeDetectorRef,) {
    this.formUpdate= this.fb.group({
      idControllo: this.fb.control(0),
      parametroId: this.fb.control(0),
      valoreArrotondato: this.fb.control(''),
      valoreRapportoProva: this.fb.control(''),
      incertezza: this.fb.control(''),
      metodo: this.fb.control(''),
      valoreLfs: this.fb.control(''),
      valoreLoq: this.fb.control(''),
      loq: this.fb.control(''),
      lfs: this.fb.control('')
    });
  }

  closeModal(): void {
    this.dialogRef.close();
  }
  changeParametro(){

    const parametroInsert = this.data.parametroInsert.filter((el:any)=>parseInt(el.id)==parseInt(this.idParamentro))
 
    if(parametroInsert){
      this.formUpdate.controls['idControllo'].setValue(parseInt(this.data.idControllo));
      this.formUpdate.controls['parametroId'].setValue(parseInt(parametroInsert[0].id));
      this.formUpdate.controls['valoreRapportoProva'].setValue(null);
      this.formUpdate.controls['valoreArrotondato'].setValue(null);
      this.formUpdate.controls['incertezza'].setValue( null );
      this.formUpdate.controls['metodo'].setValue(null);
      this.formUpdate.controls['valoreLfs'].setValue(null);
      this.formUpdate.controls['valoreLoq'].setValue( null );
      this.formUpdate.controls['loq'].setValue(null);
      this.formUpdate.controls['lfs'].setValue(null);
      this.item=parametroInsert[0]
      this.cdr.detectChanges();
    }

  }
  toFormGroup(control: any) {

    this.setValueParametroLoq(control)
    this.setValueParametroLfs(control)

  }
  setValueParametroLoq(element:any){

    if(element.get("valoreLoq").value=='<'){
        this.formUpdate.get('valoreRapportoProva')?.setValue(null)
    }
    else if(element.get("valoreLoq").value==''){
      this.formUpdate.get('valoreLoq')?.setValue(null)
      this.formUpdate.get('loq')?.setValue(null)
    }
  }
  setValueParametroLfs(element:any){
    if(element.get("valoreLfs").value=='>'){
      this.formUpdate.get('valoreRapportoProva')?.setValue(null)
    }
    else if(element.get("valoreLfs").value==''){
      this.formUpdate.get('valoreLfs')?.setValue(null)
      this.formUpdate.get('lfs')?.setValue(null)
    }
  }
  saveData(){
    this.service.addPrelievo(this.formUpdate.value).subscribe(val=>{this.dialogService.success('i dati sono stati salvati con successo', true);this.dialogRef.close("updated")});
  }
}
